import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderModule } from '@app/shared/loader/loader.module';
import { FormsModule } from '@app/shared/forms/forms.module';
import { RecommendationPopupModule } from '@app/recommendations/popup-manage/popup.module';
import { GamificationFormInputSkillsModule } from '@app/gamification';

import { ByocEpisodeComponent } from './episode.component';
import { ByocEpisodeStepLinkComponent } from './steps/link/link.component';
import { ByocEpisodeStepGeneralComponent } from './steps/general/general.component';
import { ByocEpisodeStepGeneralQuestionsComponent } from './steps/general/questions/questions.component';
import { ByocEpisodeStepGeneralQuestionsNewComponent } from './steps/general/questions/new/new.component';
import { ByocEpisodeStepGeneralQuestionsQuestionComponent } from './steps/general/questions/question/question.component';
import { ByocEpisodeStepGeneralQuestionsEditComponent } from './steps/general/questions/edit/edit.component';
import { ByocEpisodeStepCourseComponent } from './steps/course/course.component';
import { ByocEpisodeStepCourseListComponent } from './steps/course/list/list.component';
import { ByocEpisodeStepPositionComponent } from './steps/position/position.component';
import { ByocEpisodeStepPositionListComponent } from './steps/position/list/list.component';
import { ByocEpisodeStepUsersComponent } from './steps/users/users.component';
import { ByocEpisodeStepUsersListComponent } from './steps/users/list/list.component';
import { ByocEpisodeStepUsersListUserComponent } from './steps/users/list/user/user.component';
import { ByocEpisodeStepRecommendComponent } from './steps/recommend/recommend.component';
import { DirectiveCourseModule } from '../course/directive/directive-course.module';
import { SharedModule } from '@app/shared';
import { MessageModule } from '@app/shared/message';
import { TabbableModule } from '@app/shared/accesibility/tabbable/tabbable.module';
import { AriaExpandedModule } from '@app/shared/accesibility/aria-expanded/aria-expanded.module';
import { EnterKeyUpModule, SpaceKeyUpModule } from '@app/shared/accesibility/keyboard-shortcuts';
import { AriaHiddenModule } from '@app/shared/accesibility/aria-hidden/aria-hidden.module';
import { AriaLabelModule } from '@app/shared/accesibility/aria-label/aria-label.module';
import { AriaDisabledModule } from '@app/shared/accesibility/aria-disabled/aria-disabled.module';
import { FormsDropdownACModule } from '@app/shared/forms/dropdown-ac/dropdown-ac.module';
import { DataTestModule } from '@app/shared/directive/data-test';
import { ByocEpisodeStepUploadVideoComponent } from './steps/upload-video/upload-video.component';
import { FileUploaderModule } from '@app/shared/file-uploader/file-uploader.module';
import { ByocEpisodeStepUploadDocumentComponent } from './steps/upload-document/upload-document.component';
import { ByocEpisodeStepUploadedContentStatusInfoComponent } from './steps/uploaded-content-status-info/uploaded-content-status-info.component';
import { UploadContentTermsAcceptComponent } from './steps/upload-content-terms-accept/upload-content-terms-accept.component';
import { SubtitlesUploaderModule } from '@app/shared/subtitles-uploader/subtitles-uploader.module';
import { PerfectScrollbarModule } from '@app/shared/perfect-scrollbar/perfect-scrollbar.module';
import { IconComponent } from '@app/tw-shared/components';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ReactiveFormsModule,
        InlineSVGModule,
        NgbTooltipModule,
        LoaderModule,
        FormsModule,
        FormsDropdownACModule,
        DirectiveCourseModule,
        RecommendationPopupModule,
        GamificationFormInputSkillsModule,
        SharedModule,
        MessageModule,
        TabbableModule,
        AriaExpandedModule,
        EnterKeyUpModule,
        SpaceKeyUpModule,
        AriaHiddenModule,
        AriaLabelModule,
        AriaDisabledModule,
        DataTestModule,
        FileUploaderModule,
        SubtitlesUploaderModule,
        PerfectScrollbarModule,
        IconComponent,
    ],
    declarations: [
        ByocEpisodeComponent,
        ByocEpisodeStepLinkComponent,
        ByocEpisodeStepGeneralComponent,
        ByocEpisodeStepGeneralQuestionsComponent,
        ByocEpisodeStepGeneralQuestionsNewComponent,
        ByocEpisodeStepGeneralQuestionsQuestionComponent,
        ByocEpisodeStepGeneralQuestionsEditComponent,
        ByocEpisodeStepCourseComponent,
        ByocEpisodeStepCourseListComponent,
        ByocEpisodeStepPositionComponent,
        ByocEpisodeStepPositionListComponent,
        ByocEpisodeStepUsersComponent,
        ByocEpisodeStepUsersListComponent,
        ByocEpisodeStepUsersListUserComponent,
        ByocEpisodeStepRecommendComponent,
        ByocEpisodeStepUploadVideoComponent,
        ByocEpisodeStepUploadDocumentComponent,
        ByocEpisodeStepUploadedContentStatusInfoComponent,
        UploadContentTermsAcceptComponent,
    ],
})
export class ByocPopupEpisodeModule {}
